/**
 * Formats contract details into a readable string format
 * @param {Object} data - The contract data object
 * @returns {string} Formatted contract details string
 */
export const formatContractDetails = (data) => {
	const totalMiles =
		(parseInt(data?.guarantee?.total_loaded_miles) || 0) + (parseInt(data?.guarantee?.total_empty_miles) || 0);
	const startDate = data?.start_date ? new Date(data?.start_date).toLocaleDateString() : "TBD";
	const endDate = data?.end_date ? new Date(data?.end_date).toLocaleDateString() : "TBD";
	const startLocation = data?.current_location || "TBD";
	const endLocation = data?.end_location || "TBD";

	return `Contract Details:
Minimum Guaranteed Revenue: $${(data?.guarantee?.total_payment || 0).toLocaleString()}
Est. Miles (Total): ${totalMiles.toLocaleString()}
Est. RPM (Total): $${(data?.guarantee?.total_rpm || 0).toFixed(2)}
Starts in: ${startLocation}
Ends in: ${endLocation}
Start Date: ${startDate}
End Date: ${endDate}`;
};
